module.exports = __webpack_public_path__ + "img/honor7.800a3c98.jpg";